import { useContext } from "react";
import { useState, useEffect } from 'react';
import './authentication.css';
import { useQuery } from 'react-query';
import * as Api from '../../api/Api';
import * as KeyNames from '../../api/KeyNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import { GetURLParams } from '../../Components/Utils/Utils';
import { ChangePassword } from "./change-password";
import moment from "moment";

export function ResetPassword() {
    const resetToken = GetURLParams('q');
    const [resetData, setResetData] = useState(null);

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionData, resetToken ? resetToken : "NoToken"],
        async () => await Api.getResetPassword({ resetToken: resetToken }),
        {
            enabled: Boolean(resetToken)
        }
    );
    useEffect(() => {
        if (data) {

            if (data.success) {
                setResetData(data.data);
                //setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 103 });
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data, resetToken]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)


    return (
        <div>
               <div className='text-center'>
                <h1 className='text-dark mb-3'>Restablecer mi contraseña</h1>
            </div>
       
            {
                
                (resetData && (
                    localStorage.getItem(KeyNames.SessionReset) ?
                        (resetData.email === JSON.parse(localStorage.getItem(KeyNames.SessionReset)).email
                            && moment().isBefore(resetData.expirationTime)  ?
                            <ChangePassword resetToken={resetToken} />
                            : "Su proceso de cambio de contraseña expiró, por favor, solicítelo nuevamente.")//No coincide o el correo o ya expiró el token
                        : ("Ha ocurrido un error, por favor, vuelva a solicitar un cambio de contraseña.") //Ya no se enceuntra la sesión en el localStorage
                ))                    
            } 
        </div>
    )
}
